import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tri-server" }
const _hoisted_2 = ["src"]

interface Props {
  logo: string
  name: string
  desc: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AsideServer',
  props: {
    logo: { default: '' },
    name: { default: '' },
    desc: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.logo,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("h4", null, _toDisplayString(_ctx.name), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.desc), 1)
  ]))
}
}

})